import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';

/**
 * Sticky bottom CTA. Appears as soon as the user scrolls past the first
 * hero CTA button (element with id="hero-cta").
 */
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('hero-cta');
    const update = () => {
      if (!anchor) {
        setVisible(window.scrollY > 600);
        return;
      }
      const rect = anchor.getBoundingClientRect();
      setVisible(rect.bottom < 0);
    };
    update();
    window.addEventListener('scroll', update, {
      passive: true
    });
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);
  return <AnimatePresence data-id="element-105" data-mp="33inz9m32z3st">
      {visible && <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 26
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2" data-id="element-106" data-mp="2z27lsty5rgry">
          <div className="mx-auto max-w-xl rounded-2xl bg-navy/95 p-2 shadow-2xl shadow-black/40 backdrop-blur" data-id="element-107" data-mp="2ub917i64zwiw">
            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="flex animate-shake items-center justify-center gap-2 rounded-xl bg-teal-500 px-4 py-3.5 text-center text-[14px] font-extrabold uppercase tracking-wide text-white shadow-lg sm:text-base" data-id="element-108" data-mp="2fdgp6zzstq9g">
              Get the Pathway — $27 USD
              <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-109" data-mp="4lx9wxxfiyig" />
            </a>
            <p className="pb-0.5 pt-2 text-center text-[10px] font-medium text-white/70 sm:text-[11px]" data-id="element-110" data-mp="9l05lrrirsdr">
              Instant access · 7-day guarantee · Automatic currency conversion
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}